import type { SxProps } from '@mui/material';
import type { ReactNode } from 'react';

import Text, { type Color, type Props as TextProps } from '../../components/Text';

interface Props {
  placeholder?: ReactNode | string;
  color?: Color | string;
  size?: TextProps['size'];
  weight?: TextProps['weight'];
  sx?: SxProps;
}

export default function ValuePlaceholder({ placeholder, color = 'grey', size, weight, sx }: Props) {
  if (placeholder) {
    return (
      <Text
        size={size}
        color={color}
        weight={weight}
        sx={sx}
      >
        {placeholder}
      </Text>
    );
  }

  return null;
}
